const AuthTabPanel = () => {
  return <div>{"auth tabpanel"}</div>;
};

export default AuthTabPanel;
